define([
    "skylark-utils/browser"
], function(browser) {
    return browser;
});
